module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_long_auburn.1f30be7b.png";